import {
  Component,
  Input,
  TemplateRef,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';

import { faAngleDown } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'sui-select-option',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `<ng-template><ng-content /></ng-template>`,
})
export class SuiSelectOptionComponent {
  @Input() value!: unknown;
  @Input() label = '';
  @Input() disabled = false;

  @ViewChild(TemplateRef) labelTemplate!: TemplateRef<unknown>;

  faAngleDown = faAngleDown;
}
